import React from 'react';
import styles from './CVPrinter.module.scss';

function CVPrinter({ cvData, a4ContainerRef }) {
    const { firstName, lastName, designation } = cvData;
    const { email, website, phone, city, country } = cvData;
    const { experience, education } = cvData;
    const { profileImageSrc } = cvData;

    return (
        <div className={`${styles.CVPreviewMainContainer}`}>
            <div
                className={`col m-0 ${styles.CVPreviewContainer}`}
                ref={a4ContainerRef}>
                <div className={`row justify-content-between`}>
                    {/* Left CV Section */}
                    <div className={`col-7 p-0 mb-5`}>
                        <div className={`${styles.CVHeaderContainer}`}>
                            <div className={`${styles.NameContainer} mb-0`}>
                                <span className={`${styles.FirstName}`}>
                                    {firstName}
                                </span>
                                <span className={`${styles.LastName}`}>
                                    {lastName}
                                </span>
                            </div>
                            <div
                                className={`${styles.DesignationContainer} mb-0`}>
                                <span className={`${styles.Designation}`}>
                                    {designation}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className={`col-4 mb-5`}>
                        <div className={`${styles.ProfileImageContainer}`}>
                            <label
                                className={`d-flex justify-content-center align-items-center h-100 user-select-none`}>
                                <img
                                    src={profileImageSrc}
                                    alt=""
                                    className={`${styles.ProfileImage}`}
                                />
                            </label>
                        </div>
                    </div>

                    {/* Left CV Section */}
                    <div className={`col-7 p-0`}>
                        <div>
                            {experience && experience.length > 0 ? (
                                <legend className={`${styles.ExperienceTitle}`}>
                                    Experience
                                </legend>
                            ) : null}
                            <div
                                className={`${styles.ExperienceListContainer}`}>
                                <ul className={`list-unstyled`}>
                                    {experience.map(
                                        (experienceData, experienceIndex) => (
                                            <li
                                                key={experienceIndex}
                                                className={`row ${styles.ExperienceListItem}`}>
                                                <div
                                                    className={`col-12 ${styles.ExperienceDesignationContainer}`}>
                                                    <span
                                                        className={`col-12 ${styles.ExperienceDesignation}`}
                                                        style={{
                                                            width: '296px'
                                                        }}>
                                                        {
                                                            experienceData.position
                                                        }
                                                    </span>
                                                </div>
                                                <div
                                                    className={`col-12 ${styles.ExperienceCompanyContainer}`}>
                                                    <span
                                                        style={{
                                                            width: '63px'
                                                        }}
                                                        className={`col-12 ${styles.ExperienceCompany}`}>
                                                        {experienceData.company}
                                                    </span>
                                                </div>
                                                <div
                                                    className={`col-auto d-flex ${styles.ExperienceStartDateContainer}`}>
                                                    <span
                                                        style={{
                                                            width: '60px'
                                                        }}
                                                        className={`col-12 ${styles.ExperienceStartDate}`}>
                                                        {
                                                            experienceData.startDate
                                                        }
                                                    </span>
                                                </div>
                                                <div
                                                    className={`col-auto d-flex ${styles.ExperienceEndDateContainer}`}>
                                                    <span
                                                        style={{
                                                            width: '60px'
                                                        }}
                                                        className={`col-12 ${styles.ExperienceEndDate}`}>
                                                        {experienceData.endDate}
                                                    </span>
                                                </div>
                                                <div
                                                    className={`col-12 ${styles.ExperienceDescriptionContainer}`}>
                                                    <p
                                                        className={`col-12 ${styles.ExperienceDescription}`}>
                                                        {
                                                            experienceData.description
                                                        }
                                                    </p>
                                                </div>
                                            </li>
                                        )
                                    )}
                                </ul>
                            </div>

                            {education && education.length > 0 ? (
                                <>
                                    <legend
                                        className={`${styles.EducationTitle}`}>
                                        Education
                                    </legend>

                                    <div
                                        className={`${styles.EducationListContainer}`}>
                                        <ul className={`list-unstyled`}>
                                            {education.map(
                                                (
                                                    educationData,
                                                    educationIndex
                                                ) => (
                                                    <li
                                                        key={educationIndex}
                                                        className={`row ${styles.EducationListItem}`}>
                                                        <div
                                                            className={`col-12 ${styles.EducationOrganizationContainer}`}>
                                                            <span
                                                                style={{
                                                                    width: '296px'
                                                                }}
                                                                className={`col-12 ${styles.EducationOrganization}`}>
                                                                {
                                                                    educationData.organization
                                                                }
                                                            </span>
                                                        </div>
                                                        <div
                                                            className={`col-12 ${styles.EducationProgramContainer}`}>
                                                            <span
                                                                style={{
                                                                    width: '63px'
                                                                }}
                                                                className={`col-12 ${styles.EducationProgram}`}>
                                                                {
                                                                    educationData.program
                                                                }
                                                            </span>
                                                        </div>
                                                        <div
                                                            className={`col-auto d-flex ${styles.EducationStartDateContainer}`}>
                                                            <span
                                                                style={{
                                                                    width: '60px'
                                                                }}
                                                                className={`col-12 ${styles.EducationStartDate}`}>
                                                                {
                                                                    educationData.startDate
                                                                }
                                                            </span>
                                                        </div>
                                                        <div
                                                            className={`col-auto d-flex ${styles.EducationEndDateContainer}`}>
                                                            <span
                                                                style={{
                                                                    width: '60px'
                                                                }}
                                                                className={`col-auto ${styles.EducationEndDate}`}>
                                                                {
                                                                    educationData.endDate
                                                                }
                                                            </span>
                                                        </div>
                                                    </li>
                                                )
                                            )}
                                        </ul>
                                    </div>
                                </>
                            ) : null}
                        </div>
                    </div>

                    <div
                        className={`col-4 ${styles.PersonalInformationContainer}`}>
                        <div className={`mb-2 ${styles.EmailContainer}`}>
                            <span className={`${styles.Email}`}>{email}</span>
                        </div>
                        <div className={`mb-2 ${styles.WebsiteContainer}`}>
                            <span className={`${styles.Website}`}>
                                {website}
                            </span>
                        </div>
                        <div className={`mb-2 ${styles.PhoneContainer}`}>
                            <span className={`${styles.Phone}`}>{phone}</span>
                        </div>
                        <div className={`${styles.AddressContainer}`}>
                            <span className={`${styles.City}`}>{city}</span>,{' '}
                            <span className={`${styles.Country}`}>
                                {country}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CVPrinter;
